import { render } from "./MyProfile.vue?vue&type=template&id=1f3dbf4a"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"

import "./MyProfile.vue?vue&type=style&index=0&id=1f3dbf4a&lang=css"
script.render = render

export default script